import { memo } from 'react';

const EmptyText = () => {
  return (
    <div className={'flex h-[200px] w-full flex-col items-center  justify-center text-[14px] text-[#444444]'}>
      <div className="mb-[10px] h-[82px] w-[109px]">
        <img className="w-full" src="https://static.szlcsc.com/ecp/assets/newWeb/so/empty-2.svg" alt="没有找到商品" />
      </div>
      <div>抱歉，没有找到相关的商品</div>
    </div>
  );
};

export default memo(EmptyText);
